var _path, _path2, _line, _line2, _path3, _path4, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemesTribagages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9401 45.4871H16.6801V33.3071H14.9401C13.9793 33.3071 13.2001 34.0863 13.2001 35.0471V43.7471C13.2001 44.7079 13.9793 45.4871 14.9401 45.4871ZM34.0801 43.7471V35.0471C34.0801 34.0863 33.3009 33.3071 32.3401 33.3071H30.6001V45.4871H32.3401C33.3009 45.4871 34.0801 44.7079 34.0801 43.7471ZM28.8601 33.3071V30.6971C28.8601 29.2556 27.6916 28.0871 26.2501 28.0871H21.0301C19.5886 28.0871 18.4201 29.2556 18.4201 30.6971V45.4871H28.8601V33.3071ZM26.2501 33.3071H21.0301V30.6971H26.2501V33.3071Z",
    fill: "#A3AED0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9401 21.4871H16.6801V9.30713H14.9401C13.9793 9.30713 13.2001 10.0863 13.2001 11.0471V19.7471C13.2001 20.7079 13.9793 21.4871 14.9401 21.4871ZM34.0801 19.7471V11.0471C34.0801 10.0863 33.3009 9.30713 32.3401 9.30713H30.6001V21.4871H32.3401C33.3009 21.4871 34.0801 20.7079 34.0801 19.7471ZM28.8601 9.30713V6.69713C28.8601 5.25565 27.6916 4.08713 26.2501 4.08713H21.0301C19.5886 4.08713 18.4201 5.25565 18.4201 6.69713V21.4871H28.8601V9.30713ZM26.2501 9.30713H21.0301V6.69713H26.2501V9.30713Z",
    fill: "#A3AED0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.19963,
    y1: 28.087,
    x2: 7.19963,
    y2: 44.8877,
    stroke: "#A3AED0",
    strokeWidth: 2.39927,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40.7997,
    y1: 5.28676,
    x2: 40.7997,
    y2: 22.0875,
    stroke: "#A3AED0",
    strokeWidth: 2.39927,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2 35.7674C36.8024 35.7674 36.4802 36.0897 36.4802 36.4872C36.4802 36.8847 36.8024 37.207 37.2 37.207V35.7674ZM46.1089 36.9962C46.39 36.7151 46.39 36.2593 46.1089 35.9783L41.5283 31.3976C41.2472 31.1165 40.7914 31.1165 40.5103 31.3976C40.2292 31.6787 40.2292 32.1344 40.5103 32.4155L44.582 36.4872L40.5103 40.5589C40.2292 40.84 40.2292 41.2957 40.5103 41.5768C40.7914 41.8579 41.2472 41.8579 41.5283 41.5768L46.1089 36.9962ZM37.2 37.207H45.6V35.7674H37.2V37.207Z",
    fill: "#A3AED0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 11.7675C11.1976 11.7675 11.5198 12.0897 11.5198 12.4872C11.5198 12.8848 11.1976 13.207 10.8 13.207V11.7675ZM1.89109 12.9962C1.61 12.7151 1.61 12.2594 1.89109 11.9783L6.47174 7.39763C6.75283 7.11654 7.20857 7.11654 7.48966 7.39763C7.77075 7.67872 7.77075 8.13446 7.48966 8.41555L3.41797 12.4872L7.48966 16.5589C7.77075 16.84 7.77075 17.2958 7.48966 17.5769C7.20857 17.8579 6.75283 17.8579 6.47174 17.5769L1.89109 12.9962ZM10.8 13.207H2.40005V11.7675H10.8V13.207Z",
    fill: "#A3AED0"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10.8,
    y1: 25.0875,
    x2: 37.2,
    y2: 25.0875,
    stroke: "#A3AED0",
    strokeWidth: 1.19963,
    strokeDasharray: "2.4 2.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemesTribagages);
export default __webpack_public_path__ + "static/media/SystemesTribagages.e4385fb0f9e89c5631b91039b241b3c6.svg";
export { ForwardRef as ReactComponent };